import { TSortColumn, TSortDirection } from '../../classes/grid-page-info';
import { IPayer, IPayerAPI } from '../payer/payers.interface';
import { IProviderGroup } from '../provider/provider-group.interfaces';
import { IProvider, IProviderAPI } from '../provider/provider.interfaces';

export type IGroupEnrollment = {
  actionNotes: string;
  agreementApprovedDate?: Date;
  agreementDeniedDate?: Date;
  agreementSentDate?: Date;
  agreementSubmittedDate?: Date;
  caseNumber: string;
  dateLastDbUpdate?: Date;
  dateSetup?: Date;
  ediId: string;
  enrollmentId: string;
  enrollmentOwner: string;
  enrollmentStatus: string;
  enrollmentType: string;
  followUpDate?: Date;
  id: string;
  lastUpdatedBy: string;
  message: string;
  notes: string;
  npi: string;
  pMS: string;
  payer?: IPayer;
  payerId: string;
  processorId: string;
  provider?: IProvider;
  providerGroup?: IProviderGroup;
  seqNo: number;
  taxId: string;
  useApi: string;
};

export type IGroupEnrollmentDTO = {
  isExpanded: boolean;
} & IGroupEnrollment;

export type IGroupEnrollmentUpdate = {
  actionNotes: string;
  caseNumber: string;
  enrollmentId: string;
  enrollmentOwner: string;
  enrollmentStatus: string;
  followUpDate?: Date;
  message: string;
  notes: string;
  seqNo: number;
};

export type IGroupEnrollmentApi = {
  agreementApprovedDate: Date;
  agreementDeniedDate: Date;
  agreementSentDate: Date;
  agreementSubmittedDate: Date;
  caseNumber: string;
  dateLastDbUpdate: Date;
  dateSetup: Date;
  ediId: string;
  enrollmentId: string;
  enrollmentOwner: string;
  enrollmentStatus: string;
  enrollmentType: string;
  id: string;
  lastUpdatedBy: string;
  message: string;
  notes: string;
  npi: string;
  payer?: IPayerAPI;
  payerId: string;
  pms: string;
  processorId: string;
  provider?: IProviderAPI;
  seqNo: number;
  taxId: string;
  useApi: string;
  // providerGroup?: IProviderGroupAPI
};

export class GroupEnrollmentFilters {
  agreementApprovedDate?: Date;
  agreementDeniedDate?: Date;
  agreementSentDate?: Date;
  agreementSubmittedDate?: Date;
  // and?: [GroupEnrollmentFilterInput!]
  caseNumber?: string;
  dateLastDbUpdate?: Date;
  dateSetup?: Date;
  dateFrom?: string;
  dateTo?: string;
  ediId?: string;
  enrollmentId?: string;
  enrollmentOwner?: string;
  enrollmentStatus?: GroupEnrollmentStatus[];
  enrollmentType?: string;
  followUpDate?: Date;
  id?: string;
  lastUpdatedBy?: string;
  message?: string;
  notes?: string;
  npi?: string;
  // or?: [GroupEnrollmentFilterInput!]
  payer?: IPayer;
  payerId?: string;
  payerName?: string;
  pMS?: string;
  processorId?: string;
  // provider?: ProviderFilterInput
  // providerGroup?: ProviderGroupFilterInput
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showLast?: any;
  seqNo?: number;
  taxId?: string;
  useApi?: string;
}

export type GroupEnrollmentLogsFilters = {
  and?: GroupEnrollmentLogsFilters[];
  id?: number;
  or?: GroupEnrollmentLogsFilters[];
  seqNo: number;
  status?: string;
  updated?: string;
  userId?: string;
};

export type IGQLGroupEnrollmentParams = {
  after?: string;
  direction: TSortDirection;
  filter: GroupEnrollmentFilters;
  orderby: TSortColumn;
};

export type IGQLGroupEnrollmentLogParams = {
  after?: string;
  filter?: GroupEnrollmentLogsFilters;
  orderby?: TSortColumn;
  seqNo: number;
};

export type IGroupEnrollmentPayersParams = {
  EnrollmentType?: string | string[];
  Id?: number;
  ScId?: string;
  limit?: number;
  skip?: number;
};

export type IGroupEnrollmentPayer = {
  dateLastDbUpdate: Date;
  dateSetup: Date;
  doc1: string;
  doc2: string;
  doc3: string;
  doc4: string;
  doc5: string;
  enrollmentType: string;
  id: number;
  lastUpdatedBy: string;
  notes: string;
  payerName: string;
  payerState: string;
  processorId: string;
  scId: string;
  submitterIdRequired: string;
  url: string;
};

export type IGroupEnrollmentStatus = {
  code: string;
  description: string;
};

export type IGroupEnrollmentLog = {
  id?: number;
  seqNo?: number;
  status?: string;
  updated?: string;
  userId?: string;
  userName: string;
};

export const GroupEnrollmentStatuses = {
  C: 'Sent to Customer',
  A: 'Approved',
  S: 'Submitted',
  D: 'Denied',
  N: 'Not Applicable',
  P: 'To be sent',
  I: 'Inactive',
  F: 'Automated setup failed',
  W: 'ERA approval received',
  M: 'Manual action required',
} as const;

export type GroupEnrollmentStatusKey = keyof typeof GroupEnrollmentStatuses;
export type GroupEnrollmentStatus =
  (typeof GroupEnrollmentStatuses)[GroupEnrollmentStatusKey];

export const GroupEnrollmentStatuses2 = {
  A: 'agreementApprovedDate',
  C: 'agreementSentDate',
  D: 'agreementDeniedDate',
  FUD: 'followUpDate',
  I: 'dateSetup',
  N: 'dateSetupN',
  P: 'dateSetupP',
  S: 'agreementSubmittedDate',
} as const;

export type GroupEnrollmentStatus2Key = keyof typeof GroupEnrollmentStatuses2;
export type GroupEnrollmentStatusDate =
  (typeof GroupEnrollmentStatuses2)[GroupEnrollmentStatus2Key];

export type IGroupEnrollmentBillingIdListItemGQL = {
  billingId: string;
};
